import { api, http, web } from './services/http.ts'

// Polyfill for `Array.fromAsync`.
if (!Array.fromAsync) {
  Array.fromAsync = async (iterable: AsyncGenerator) => {
    const result = []

    for await (const item of iterable) {
      result.push(item)
    }

    return result
  }
}

window.web = web
window.http = http
window.api = api

window.initialStatePromise = api.get('initial-state')

window.nextFrame = nextFrame
window.delay = delay

window.copyObject = (obj) => JSON.parse(JSON.stringify(obj))
